import React from 'react';
import Styled from 'styled';
import SVGIcon from 'lib/images/svg-icon/svg-icon';
import camera from 'four-nets/icons/svg/icon_photo.svg';
import EventBarrier from 'photoswipe/event-barrier/event-barrier';
import Photoswipe from 'photoswipe';
import defaultStyles from './ui.scss';
import leftStyles from './left.scss';
import rightStyles from './right.scss';

import Arrow from './arrow/arrow';

export interface Props {
    styles: typeof defaultStyles;
    photoswipe?: Photoswipe<Photoswipe.Options> | null;
    total?: number;
    unshift?: boolean;
    newImagesCount?: number;
}

interface State {
    total?: number;
    current?: number;
}

class Ui extends React.PureComponent<Props, State> {
    state: State = { total: this.props.total };

    addListeners(photoswipe: PhotoSwipe<Photoswipe.Options>) {
        const handler = () => {
            const { total, unshift, newImagesCount } = this.props;

            let current = photoswipe.getCurrentIndex() + 1;
            if (newImagesCount && total && total !== photoswipe.items.length && unshift) {
                current = total - newImagesCount + current;
            }

            this.setState({
                current,
                total: total || photoswipe.items.length,
            });
        };

        photoswipe.listen('beforeChange', handler);
        photoswipe.listen('beforeResize', handler);
    }

    componentDidMount() {
        if (this.props.photoswipe) {
            this.addListeners(this.props.photoswipe);
        }
    }

    componentDidUpdate(prevProps: Props) {
        if (prevProps.photoswipe !== this.props.photoswipe && this.props.photoswipe) {
            this.addListeners(this.props.photoswipe);
        }
    }

    prev = (event: React.SyntheticEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        event.nativeEvent.stopPropagation();
        event.nativeEvent.stopImmediatePropagation();

        if (this.props.photoswipe) {
            this.props.photoswipe.prev();
        }
    };

    next = (event: React.SyntheticEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        event.nativeEvent.stopPropagation();
        event.nativeEvent.stopImmediatePropagation();

        if (this.props.photoswipe) {
            this.props.photoswipe.next();
        }
    };

    render() {
        const { styles } = this.props;
        const { total, current } = this.state;

        return (
            <EventBarrier>
                {total! > 1 && current! > 0 ? (
                    <div className={styles!.counter}>
                        <SVGIcon style={{ image: styles.icon }} src={camera} />
                        {current}/{total}
                    </div>
                ) : null}
                {total! > 1 ? (
                    <React.Fragment>
                        <Arrow style={{ arrow: leftStyles.left }} onClick={this.prev} onTouchEnd={this.prev} />
                        <Arrow style={{ arrow: rightStyles.right }} onClick={this.next} onTouchEnd={this.next} />
                    </React.Fragment>
                ) : null}
            </EventBarrier>
        );
    }
}

export default Styled(defaultStyles)(Ui);
